module.exports = __webpack_public_path__ + "static/media/fm-icons-Facemouth_logo_small.49cfeaa2.svg";